<div class="border-0 px-4 py-1 overflow-auto">
  <div class="company-second-card rounded-lg shadow p-5 border glass-card mt-2">

    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative probaworkflows-bg">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <h1 class="hero-title text-white text-x fw-bold">Saved Template Library</h1>
          <p class="hero-description mt-1 text-white text-xs">
            Review reusable templates, inspect their setup, and generate new report outputs directly from the saved configuration.
          </p>
        </div>
      </section>
      <div class="d-flex gap-2 justify-content-md-end mt-5">
        <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" type="button" @click="go_to_generate_reports">
          Build New Report
        </button>
        <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" type="button" @click="go_to_generated_reports">
          View Generated Reports
        </button>
      </div>
    </div>

    <ReportTemplateLibrary
      title="Report Templates"
      subtitle="Quick-generate a report in the selected output format or open a template in the builder to edit it."
    />
  </div>
</div>
